import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { PrismicRichText } from '@prismicio/react'

const Contact = ({ slice }) => {
  const inputClass = 'focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
  return (
    <section className={`component-${slice.slice_type} px-8 py-5 md:py-10 relative max-w-7xl mx-auto lg:grid lg:grid-cols-5 lg:gap-10`}>
      <div className='max-w-screen-2xl col-span-2 mt-4 prose prose-lg dark:prose-invert'>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      <form
        name='contact'
        method='POST'
        action='/success'
        data-netlify='true'
        data-netlify-honeypot='bot-field'
        netlify-honeypot='bot-field'
        data-netlify-recaptcha='true'
        className='col-span-3 lg:px-10 lg:border-l dark:lg:border-gray-700 space-y-4'>
        <input type='hidden' name='subject' data-remove-prefix value='New %{formName} submission' />
        <input type='hidden' name='bot-field' />
        <input type='hidden' name='form-name' value='contact' />
        <div>
          <label className='block text-lg mb-2' htmlFor='name'>
            What's your name?
          </label>
          <input className={inputClass} type='text' name='name' id='name' required />
        </div>
        <div>
          <label className='block text-lg mb-2' htmlFor='email'>
            What's your email address?
          </label>
          <input className={inputClass} type='email' name='email' id='email' required />
        </div>
        <div>
          <label className='block text-lg mb-2' htmlFor='phone'>
            What's your phone number?
          </label>
          <input className={inputClass} type='tel' name='phone' id='phone' placeholder='Optional' />
        </div>
        <div>
          <label className='block text-lg mb-2' htmlFor='message'>
            How can we help?
          </label>
          <textarea rows='4' className={inputClass} name='message' id='message' required></textarea>
        </div>
        <div>
          <ReCAPTCHA sitekey={process.env.GATSBY_SITE_RECAPTCHA_KEY} />
        </div>
        <div>
          <button type='submit' className='button rounded w-full sm:w-auto'>
            Send your enquiry
          </button>
        </div>
      </form>
    </section>
  )
}

export default Contact
